<template>
  <div class="col-12 row q-col-gutter-x-sm items-center">
    <model-form-select
      :field="voucherTypesField"
      class="col-8"
      :label="`${(conditional.conditionsRequirements[excludeVoucherTypesField] ? 'Exclude' : 'Include')} Vouchers`"
      :options="voucherTypes.data"
      option-label="name"
      option-value="id"
      map-options
      emit-value
      multiple
      use-chips
      clearable
      :rules="[
        val => !!val || 'Field is required',
        val => val.length > 0 || 'Must select at least one voucher type'
      ]"
    >
      <template #option="scope">
        <q-item
          v-bind="scope.itemProps"
          v-on="scope.itemEvents"
        >
          <q-item-section>
            {{ scope.opt.name }}
          </q-item-section>
        </q-item>
      </template>
    </model-form-select>
    <model-form-toggle
      :field="`conditionsRequirements.${excludeVoucherTypesField}`"
      class="col-4 q-mb-md"
      label="Exclude"
      value-type="Boolean"
    />
  </div>
</template>

<script>
import { CONDITION_REQUIREMENTS } from 'src/models/membership-type/MembershipPoint'

export default {
  name: 'VoucherTypesConditionForm',
  configuration: ['voucherTypes'],
  props: {
    conditional: {
      type: Object,
      required: true
    },
    voucherTypesField: {
      type: String,
      default: CONDITION_REQUIREMENTS.VOUCHERS
    },
    excludeVoucherTypesField: {
      type: String,
      default: CONDITION_REQUIREMENTS.EXCLUDE_VOUCHERS
    }
  }
}

</script>
